import {NavigationPageEnum, NavigationPageEnumHumanReadable} from '../../navigations.enums';
import {IUserAccessFeature} from '../user-access-features';
import {SettingsReferenceEnum} from '../../../../settings-new/models';
import {
  _DEFAULT_USER_ACCESS_APPLICATION_PREFERENCE_SETTINGS,
  IUserAccessApplicationPreferenceSettings,
} from '../access';

//#region INTERFACE IFeatureApplicationPreferences
export interface IFeatureApplicationPreferences extends IUserAccessFeature, Object {
  crudAccess: IUserAccessApplicationPreferenceSettings;
}

//#endregion

//#region CONST _FEATURE_APPLICATION_PREFERENCES_DEFAULT
export const _FEATURE_APPLICATION_PREFERENCES_DEFAULT: Readonly<IFeatureApplicationPreferences & Object> = {
  displayText: NavigationPageEnumHumanReadable.Preferences,
  feature: NavigationPageEnum.Preferences,
  ref: SettingsReferenceEnum.applicationPreferences,
  standalone: true,
  crudAccess: {
    ..._DEFAULT_USER_ACCESS_APPLICATION_PREFERENCE_SETTINGS,
  },
};
//#endregion